import { updateExternalConnection as _updateExternalConnection } from '@griply/services';
import { ExternalConnection } from '@griply/types';
import {
  doc,
  getFirestore,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';

export const updateExternalConnection = (
  externalConnection: Pick<ExternalConnection, 'id'> &
    Partial<ExternalConnection>,
): Promise<void> =>
  _updateExternalConnection({
    externalConnection,
    doc,
    updateDoc,
    db: getFirestore(),
    serverTimestamp,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.UpdateExternalConnection,
        error,
        docPath: `external-connections/${externalConnection.id}`,
      }),
  });
